import type { VNode } from 'preact';
import { CopyToClipboardTrigger } from '@core/components/Generics/CopyToClipboardTrigger';

export interface PermissionDeniedOverlayProps {
  errorMessage: string;
  visible?: boolean;
  showCopyLinkGuidance?: boolean;
  onClose?: () => void;
}

export function PermissionDeniedOverlay({
  errorMessage,
  visible = true,
  showCopyLinkGuidance = false,
  onClose,
}: PermissionDeniedOverlayProps): VNode {
  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      window.location.reload();
    }
  };

  if (!visible || !errorMessage) {
    return <div style={{ display: 'none' }} />;
  }

  const [errorPrimary, errorSecondary] = errorMessage.split(/<br\s*\/?>\s*<br\s*\/?>/i);
  const hasErrorSecondary = Boolean(errorSecondary && errorSecondary.trim().length > 0);

  return (
    <div className="fixed inset-0 z-[100] bg-black text-white flex flex-col px-5">
      {showCopyLinkGuidance ? (
        <div className="flex-1 flex flex-col items-center justify-end pb-[60px] gap-8 text-center animate-fade-in">
          <p className="font-light text-[18px] leading-[1.4] px-4 max-w-[340px]">
            To run this experience copy the link below and paste it in your Chrome browser.
          </p>
          <CopyToClipboardTrigger text={window.location.href} color="white">
            <div className="border-2 min-w-[250px] border-white border-opacity-30 py-3 px-4 max-w-xs flex gap-x-2 relative cursor-pointer transition-opacity duration-200 hover:opacity-50 hover:border-opacity-50">
              <span className="flex-grow text-center whitespace-nowrap overflow-hidden text-ellipsis w-full tracking-[1px]">
                COPY LINK
              </span>
            </div>
          </CopyToClipboardTrigger>
        </div>
      ) : (
        <div className="flex-1 flex flex-col justify-end pb-[60px]">
          <div className="text-[20px] text-center font-light w-full mx-auto flex flex-col items-center animate-fade-in">
            <div
              className="font-medium"
              dangerouslySetInnerHTML={{ __html: errorPrimary || errorMessage }}
            />
            {hasErrorSecondary && <div className="h-px w-[40px] bg-white/40 my-8" />}
            {hasErrorSecondary && (
              <div
                className="font-light text-[18px]"
                dangerouslySetInnerHTML={{ __html: errorSecondary }}
              />
            )}
          </div>
          <div className="w-full max-w-[260px] mx-auto mt-[78px]">
            <button
              onClick={handleClose}
              className="w-full h-[56px] rounded-full bg-transparent border-2 border-white text-white font-medium text-[16px] tracking-[0.05em] uppercase transition-colors active:bg-white active:text-black md:hover:bg-white md:hover:text-black"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
